export const reportCodes = {
  CreditMemo: 'CREDIT_MEMO',
}
